import ArrowRight from 'lucide-react/dist/esm/icons/arrow-right.js';
import Archive from 'lucide-react/dist/esm/icons/archive.js';
import Bell from 'lucide-react/dist/esm/icons/bell.js';
import CalendarClock from 'lucide-react/dist/esm/icons/calendar-clock.js';
import CalendarX from 'lucide-react/dist/esm/icons/calendar-x.js';
import Check from 'lucide-react/dist/esm/icons/check.js';
import CheckCheck from 'lucide-react/dist/esm/icons/check-check.js';
import ChevronDown from 'lucide-react/dist/esm/icons/chevron-down.js';
import ChevronUp from 'lucide-react/dist/esm/icons/chevron-up.js';
import CircleCheck from 'lucide-react/dist/esm/icons/circle-check.js';
import CircleCheckBig from 'lucide-react/dist/esm/icons/circle-check-big.js';
import CircleMinus from 'lucide-react/dist/esm/icons/circle-minus.js';
import CircleX from 'lucide-react/dist/esm/icons/circle-x.js';
import Clock from 'lucide-react/dist/esm/icons/clock.js';
import ClockAlert from 'lucide-react/dist/esm/icons/clock-alert.js';
import DoorClosed from 'lucide-react/dist/esm/icons/door-closed.js';
import Eye from 'lucide-react/dist/esm/icons/eye.js';
import EyeOff from 'lucide-react/dist/esm/icons/eye-off.js';
import FilePlus2 from 'lucide-react/dist/esm/icons/file-plus-2.js';
import Inbox from 'lucide-react/dist/esm/icons/inbox.js';
import Info from 'lucide-react/dist/esm/icons/info.js';
import OctagonAlert from 'lucide-react/dist/esm/icons/octagon-alert.js';
import SearchX from 'lucide-react/dist/esm/icons/search-x.js';
import ServerCrash from 'lucide-react/dist/esm/icons/server-crash.js';
import TriangleAlert from 'lucide-react/dist/esm/icons/triangle-alert.js';
import UserCheck from 'lucide-react/dist/esm/icons/user-check.js';
import Users from 'lucide-react/dist/esm/icons/users.js';
import WifiOff from 'lucide-react/dist/esm/icons/wifi-off.js';
import X from 'lucide-react/dist/esm/icons/x.js';
export { ArrowRight, Archive, Bell, CalendarClock, CalendarX, Check, CheckCheck, ChevronDown, ChevronUp, CircleCheck, CircleCheckBig, CircleMinus, CircleX, Clock, ClockAlert, DoorClosed, Eye, EyeOff, FilePlus2, Inbox, Info, OctagonAlert, SearchX, ServerCrash, TriangleAlert, UserCheck, Users, WifiOff, X, };
/**
 * Keyed by `LifecycleEntry.icon` (`i18n/lifecycle-labels.ts`) — DESIGN_SYSTEM.md §9's
 * file-stage / appointment-status / officer-availability icon-concept column.
 */
export const LIFECYCLE_ICONS = {
    'document-plus': FilePlus2,
    'user-check': UserCheck,
    eye: Eye,
    'arrow-right': ArrowRight,
    'check-circle': CircleCheckBig,
    'x-circle': CircleX,
    'check-circle-double': CheckCheck,
    'archive-box': Archive,
    'alert-triangle': TriangleAlert,
    clock: Clock,
    'calendar-clock': CalendarClock,
    'clock-x': ClockAlert,
    'circle-check': CircleCheck,
    'circle-minus': CircleMinus,
    users: Users,
    'calendar-x': CalendarX,
    door: DoorClosed,
};
//# sourceMappingURL=index.js.map